// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"85ffb0d9","650":"78043108","825":"42a3c0dc","863":"5afb4ae8","865":"1e6eceea"}[chunkId] + ".chunk.js";
};